import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const BUYER_NAMES = ['María G.', 'Carlos R.', 'Ana P.', 'Luis M.', 'Sofía T.', 'Diego H.', 'Valentina S.', 'Andrés L.', 'Camila F.', 'Jorge V.', 'Isabella R.', 'Fernando C.', 'Daniela M.', 'Roberto A.', 'Lucía B.', 'Alejandro D.', 'Paula N.', 'Sebastián O.', 'Gabriela E.', 'Martín Q.', 'Laura K.', 'Ricardo J.', 'Natalia W.', 'Eduardo Z.', 'Carmen I.'];
export function SocialProofToasts() {
  const [currentBuyer, setCurrentBuyer] = useState<string | null>(null);
  useEffect(() => {
    const showToast = () => {
      const name = BUYER_NAMES[Math.floor(Math.random() * BUYER_NAMES.length)];
      setCurrentBuyer(name);
      setTimeout(() => setCurrentBuyer(null), 4000);
    };
    const initialTimeout = setTimeout(showToast, 5000);
    const interval = setInterval(showToast, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-298">
      {currentBuyer && <motion.div initial={{
      opacity: 0,
      x: -80,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -80
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="fixed top-2 left-2 right-2 z-[100] flex justify-center pointer-events-none" data-id="element-299">
          <div className="max-w-md w-full pointer-events-auto" data-id="element-300">
            <div className="bg-white border border-gray-200 rounded-lg px-3 py-2.5 shadow-xl flex items-center gap-2.5" data-id="element-301">
              <div className="bg-primary/10 rounded-full p-1.5 shrink-0" data-id="element-302">
                <ShoppingBag className="w-3.5 h-3.5 text-primary" data-id="element-303" />
              </div>
              <div className="text-left" data-id="element-304">
                <p className="text-xs font-bold text-dark leading-tight" data-id="element-305">
                  {currentBuyer} compró el programa
                </p>
                <p className="text-[10px] text-gray-400" data-id="element-306">Hace unos momentos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}